import { Injectable } from '@angular/core';
import { StepImpl } from '../../models/steps/step-impl';
import { DummyStep } from '../../models/steps/dummy-step';
import { FormStep } from '../../models/steps/form-step';
import { OrderService } from '../order/order.service';
import { Control } from '../../models/controls/control';

@Injectable({
  providedIn: 'root',
})
export class StepVerificationService {
  private readonly steps: StepImpl[] = [];

  constructor(private readonly orderService: OrderService) {}

  init(steps: StepImpl[]): void {
    steps.forEach((step) => this.addStep(step));
  }

  getFirstInvalidStep(): StepImpl {
    return this.steps.find((step) => !step.isReady()) || new DummyStep();
  }

  private addStep(step: StepImpl): void {
    this.steps.push(step);
    if (!step.isReady() && step instanceof FormStep && this.isStepValid(step)) {
      step.setReady();
    }
  }

  private isStepValid(step: FormStep): boolean {
    let valid = step.forms.length > 0;
    step.forms.forEach((form) => {
      if (form.length === 0) {
        valid = false;
        return;
      }
      if (valid) {
        valid = this.isFormValid(form);
      }
    });
    return valid;
  }

  private isFormValid(form: Control<any>[]): boolean {
    let valid = true;
    form.forEach((control) => {
      if (valid && !this.orderService.isControlValid(control)) {
        valid = false;
      }
    });
    return valid;
  }
}
